/**
 * Error renderer for initialization failures
 *
 * Displays a user-friendly error state when the add-in fails to load.
 */
function escapeHtml(text) {
    const htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
    };
    return text.replace(/[&<>"']/g, (char) => htmlEscapes[char]);
}
export function renderError(container, error) {
    console.error('[Init] Rendering error state:', error);
    const escapedMessage = escapeHtml(error.message);
    container.innerHTML = `
        <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100vh;
            padding: 24px;
            text-align: center;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            background: #fafafa;
        ">
            <div style="
                background: white;
                border-radius: 12px;
                padding: 32px;
                max-width: 400px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            ">
                <div style="
                    color: #dc2626;
                    font-size: 48px;
                    margin-bottom: 16px;
                ">⚠</div>
                <h2 style="
                    color: #1f2937;
                    font-size: 18px;
                    font-weight: 600;
                    margin: 0 0 12px 0;
                ">Unable to Load Add-in</h2>
                <p style="
                    color: #6b7280;
                    font-size: 14px;
                    margin: 0 0 20px 0;
                    line-height: 1.5;
                ">
                    Something went wrong while loading the add-in.
                    Please try refreshing or contact support if the problem persists.
                </p>
                <button onclick="window.location.reload()" style="
                    background-color: #4f46e5;
                    color: white;
                    padding: 10px 20px;
                    border: none;
                    border-radius: 6px;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 500;
                ">Try Again</button>
                <details style="
                    margin-top: 20px;
                    text-align: left;
                ">
                    <summary style="
                        color: #9ca3af;
                        font-size: 12px;
                        cursor: pointer;
                    ">Technical Details</summary>
                    <pre style="
                        background: #f3f4f6;
                        padding: 12px;
                        border-radius: 6px;
                        font-size: 11px;
                        overflow: auto;
                        margin-top: 8px;
                        color: #374151;
                    ">${escapedMessage}</pre>
                </details>
            </div>
        </div>
    `;
}
